/**
 * Written by Windsurf using model: Claude Sonnet 4.5 (Thinking)
 */
import { useState } from 'react'
import { Box, IconButton, Typography, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface ScenarioCardHeaderProps {
  readonly index: number
  readonly onDelete: () => void
}

export default function ScenarioCardHeader({
  index,
  onDelete,
}: Readonly<ScenarioCardHeaderProps>) {
  const theme = useTheme()
  const [hoverDelete, setHoverDelete] = useState(false)

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 1,
      }}
    >
      <Typography variant="h6" color={theme.palette.primary.main}>
        Scenario {index + 1}
      </Typography>
      <IconButton
        size="small"
        onClick={onDelete}
        onMouseEnter={() => setHoverDelete(true)}
        onMouseLeave={() => setHoverDelete(false)}
        sx={{
          ml: 1,
          color: hoverDelete ? 'error.main' : 'action.active',
          opacity: hoverDelete ? 1 : 0.7,
          '&:hover': {
            backgroundColor: 'transparent',
            opacity: 1,
          },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  )
}
